import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
  scrollBehavior (to, from, savedPosition) {
    // 解决路由跳转后，会滚动到底部
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0 , y: 0}
    }
  },
  routes: [{
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue')
    },
    // 新闻咨询
    {
      path: '/news',
      name: 'news',
      component: () => import('./views/News.vue'),
    },
    {
      path: '/newsdetails/:id',
      name: 'newsdetails',
      component: () => import('./views/NewsDetails.vue'),
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('./views/Product.vue'),
    },    
    // 产品 
    {
      path: '/product1',
      name: 'product1',
      component: () => import('./views/Product/Product1.vue'),
    },
    {
      path: '/product2',
      name: 'product2',
      component: () => import('./views/Product/Product2.vue'),
    },
    {
      path: '/product3',
      name: 'product3',
      component: () => import('./views/Product/Product3.vue'),
    },
    {
      path: '/product32',
      name: 'product32',
      component: () => import('./views/Product/Product3_2.vue'),
    },
    {
      path: '/product4',
      name: 'product4',
      component: () => import('./views/Product/Product4.vue'),
    },
    {
      path: '/product5',
      name: 'product5',
      component: () => import('./views/Product/Product5.vue'),
    },
    {
      path: '/product6',
      name: 'product6',
      component: () => import('./views/Product/Product6.vue'),
    },
    // {
    //   path: '/productdetails/:id',
    //   name: 'productdetails',
    //   component: () => import('./views/ProductDetails.vue')
    // },
    // 解决方案
    {
      path: '/solve',
      name: 'solve',
      component: () => import('./views/Solve.vue'),
    },
    // {
    //   path: '/case',
    //   name: 'case',
    //   component: () => import('./views/Case.vue')
    // },
    // {
    //   path: '/casedetails/:id',
    //   name: 'casedetails',
    //   component: () => import('./views/CaseDetails.vue')
    // },
    {
      path: '/goin',
      name: 'goin',
      component: () => import('./views/GoIn.vue')
    },
    // {
    //   path: '/download',
    //   name: 'download',
    //   component: () => import('./views/Download.vue')
    // },
    // {
    //   path: '/buildings',
    //   name: 'buildings',
    //   component: () => import('./views/Buildings.vue')
    // },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: () => import('./views/Login.vue')
    // },
    // {
    //   path: '/admin',
    //   name: 'admin',
    //   meta: {
    //     requireAuth: true
    //   },
    //   component: () => import('./views/Admin.vue'),
    //   children: [{
    //       path: '/admin/user',
    //       name: 'user',
    //       component: () => import('./views/Admin/User.vue')
    //     },
    //     {
    //       path: '/admin/news',
    //       name: 'new',
    //       component: () => import('./views/Admin/News.vue')
    //     },
    //     {
    //       path: '/admin/cases',
    //       name: 'cases',
    //       component: () => import('./views/Admin/Cases.vue')
    //     },
    //     {
    //       path: '/admin/team',
    //       name: 'team',
    //       component: () => import('./views/Admin/Team.vue')
    //     },
    //     {
    //       path: '/admin/course',
    //       name: 'course',
    //       component: () => import('./views/Admin/Course.vue')
    //     },
    //     {
    //       path: '/admin/enterprise',
    //       name: 'enterprise',
    //       component: () => import('./views/Admin/Enterprise.vue')
    //     },
    //     {
    //       path: '/admin/honor',
    //       name: 'honor',
    //       component: () => import('./views/Admin/Honor.vue')
    //     },
    //     {
    //       path: '/admin/dictionary',
    //       name: 'dictionary',
    //       component: () => import('./views/Admin/Dictionary.vue')
    //     },
    //     {
    //       path: '/admin/page',
    //       name: 'page',
    //       component: () => import('./views/Admin/Page.vue')
    //     }
    //   ]
    // }
  ]
})

// 判断是否需要登录权限 以及是否登录
// kejianrouter.beforeEach((to, from, next) => {
//   // 判断是否需要登录权限
//   if (to.matched.some(res => res.meta.requireAuth)) {
//     // 判断是否登录
//     if (sessionStorage.getItem('token')) {
//       next()
//     } else {
//       // 没登录则跳转到登录界面
//       next({
//         path: '/login',
//         query: {
//           redirect: to.fullPath
//         }
//       })
//     }
//   } else {
//     next()
//   }
// })

export default kejianrouter